import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { MimicFolderEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class MimicFolderSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    mimicFolderCreated$() {
        return this.socketService.receiveMessageObserver(MimicFolderEvents.MIMIC_FOLDER_CREATED);
    }

    mimicFolderUpdated$() {
        return this.socketService.receiveMessageObserver(MimicFolderEvents.MIMIC_FOLDER_UPDATED);
    }

    mimicFolderDeleted$() {
        return this.socketService.receiveMessageObserver(MimicFolderEvents.MIMIC_FOLDER_DELETED);
    }

    mimicFolderUpdatedIndex$() {
        return this.socketService.receiveMessageObserver(MimicFolderEvents.MIMIC_FOLDER_INDEX_UPDATE);
    }
}
